import React from 'react';
import { layout, palette } from '@citrite/web-ui-component';
import { AdaptiveDropdown, ContextMenuItem } from '@citrite/workspace-ui-platform-react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useResourceManagerContext } from 'App/Activity/ResourceManagerContext';
import { useFormFactor } from 'App/Header/useFormFactor';
import { shouldCallResourceSessionsRefresh } from 'App/Tile/utils';
import { useConfigurationContext } from 'Configuration/useConfigurationContext';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

const StyledDiv = styled.div<{
	isSmallFormFactor: boolean;
}>`
	position: absolute;
	top: ${layout.smallSpace};
	right: ${layout.smallSpace};
	text-align: left;
	${props =>
		props.isSmallFormFactor &&
		`
		position: relative;
		top: 0;
		right: 0;
		text-align: end;
	`}
`;

const dropdownMenuStyles = {
	menuStyleList: css`
		border-radius: ${layout.smallSpace};
		padding: ${layout.smallSpace};
		ul {
			display: flex;
			flex-direction: column;
			gap: ${layout.smallSpace};
		}
	`,
	listItemStyle: css`
		padding: 0px ${layout.smallSpace};
		&:hover {
			border-radius: ${layout.tinySpace};
			background-color: ${palette.grey100};
		}
	`,
	listItemTextStyle: css`
		padding: 0;
	`,
};

interface Props {
	resource: Resource;
	contextMenuBuilder: (resource: Resource) => ContextMenuItem[];
}

export const ResourceMenu = ({ resource, contextMenuBuilder }: Props) => {
	const { isSmallFormFactor } = useFormFactor();
	const { refresh } = useResourceManagerContext();
	const { workspaceConfiguration } = useConfigurationContext();

	const handleSessionListRefresh = () => {
		if (shouldCallResourceSessionsRefresh(resource, workspaceConfiguration)) {
			refresh();
		}
	};

	const onClick = (event: React.MouseEvent<HTMLElement>) => {
		if (!isSmallFormFactor) {
			handleSessionListRefresh();
		}
		event.stopPropagation();
	};

	return (
		<StyledDiv
			onClick={onClick}
			data-testid={`${resource.id}-more-action`}
			data-analytics-name="tile-more-action"
			isSmallFormFactor={isSmallFormFactor}
			className="resource-menu-container"
		>
			<AdaptiveDropdown
				name={resource.name}
				data={resource}
				showMobileActionSheet={isSmallFormFactor}
				contextMenuBuilder={contextMenuBuilder}
				placement="bottom-start"
				onShowCallback={handleSessionListRefresh}
				dropdownProps={dropdownMenuStyles}
			/>
		</StyledDiv>
	);
};
